import { optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import {
	WarmupDataDefinition as definition,
	WarmupDataService as impl,
	type IWarmupDataDefinition,
	type IWarmupDataServiceConfig,
} from '@wix/site-service-warmup-data'
import { WARMUP_DATA_SERVICE_DATA_KEY, WarmupDataProviderSymbol, WarmupDataServiceStoreSymbol } from './symbols'
import type { IWarmupDataProvider, IWarmupDataServiceStore, WarmupDataServiceWarmupData } from './types'

const warmupDataServiceFactory = withDependencies(
	[WarmupDataProviderSymbol, optional(WarmupDataServiceStoreSymbol)],
	(
		warmupDataProvider: IWarmupDataProvider,
		warmupDataServiceStore?: IWarmupDataServiceStore
	): ServiceProvider<IWarmupDataDefinition, typeof impl> => {
		const config: IWarmupDataServiceConfig = {
			getData: async (key) => {
				if (warmupDataServiceStore) {
					return warmupDataServiceStore.get(key)
				}

				const warmupData =
					await warmupDataProvider.getWarmupData<WarmupDataServiceWarmupData>(WARMUP_DATA_SERVICE_DATA_KEY)
				return warmupData?.[key] ?? null
			},
			setData: (key, data) => {
				if (!warmupDataServiceStore) {
					throw new Error('Setting builder component warmup data is only supported during SSR')
				}
				warmupDataServiceStore.set(key, data)
			},
		}

		return {
			definition,
			impl,
			config,
		}
	}
)

export const WarmupDataService: FactoryWithDependencies<ServiceProvider<IWarmupDataDefinition>> =
	warmupDataServiceFactory
